import { render } from "./ItemFilter.vue?vue&type=template&id=313ad501"
import script from "./ItemFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__